// import { debounce } from "lodash";
// import moment from "moment";
// import { Fragment, useEffect, useRef, useState } from "react";
// import { MoreVertical, PlusCircle } from "react-feather";
// import { FaPen, FaTrashAlt } from "react-icons/fa";
// import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row, UncontrolledDropdown } from "reactstrap";
// import { baseURL } from "../../../../Services/api/baseURL";
// import axios from "axios";
// import { useFormik } from "formik";
// import * as Yup from 'yup'
// import Swal from "sweetalert2";
// import DataTable from "react-data-table-component";
// import CommonModal from "../../../UiKits/Modals/common/modal";
// import Loader from "../../../Loader/Loader";

// const CouponsTable = () => {
//     const [searchTerm, setSearchTerm] = useState('');
//     const [AddModal, SetAddmodal] = useState(false);
//     const [data, setData] = useState([])
//     const [token, setToken] = useState(null);
//     const [id, setId] = useState("");
//     const [isLoading, setIsLoading] = useState(false);
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         const token = JSON.parse(localStorage.getItem('token'))
//         if (token) {
//             setToken(token);
//             return;
//         }
//         setToken(null);
//     }, []);

//     const formik = useFormik({
//         initialValues: {
//             code: "",
//             // description: "",
//             discountType: "percentage",
//             discountValue: "",
//             minOrderVal: "",
//             maxAmount: "",
//             createdAt: moment().format("YYYY-MM-DD"), // default to today
//             expiryDate: "",
//         },
//         validationSchema: Yup.object({
//             code: Yup.string()
//                 .transform((v) => v?.toUpperCase())
//                 .required("Coupon Code is required"),

//             // description: Yup.string()
//             //     .max(150, "Description should be concise (max 150 chars)")
//             //     .required("Description is required"),

//             discountValue: Yup.number()
//                 .typeError("Discount Value must be a number")
//                 .positive("Discount must be positive")
//                 .required("Discount Value is required"),

//             discountType: Yup.string()
//                 .oneOf(["percentage", "flat"], "Invalid Discount Type")
//                 .required("Discount Type is required"),

//             minOrderVal: Yup.number()
//                 .typeError("Min Order Value must be a number")
//                 .min(0, "Cannot be negative")
//                 .required("Minimum Order Value is required"),

//             maxAmount: Yup.number()
//                 .typeError("Max Discount Amount must be a number")
//                 .min(0, "Cannot be negative")
//                 .required("Maximum Discount Amount is required"),

            
//         createdAt: Yup.date()
//             .when([], {
//                 // 'id' is taken from outer scope
//                 is: () => !id, // only validate "no past" when creating
//                 then: (schema) =>
//                     schema
//                         .min(
//                             moment().subtract(1, "day").toDate(),
//                             "Start Date cannot be in the past"
//                         )
//                         .required("Start Date is required"),
//                 otherwise: (schema) =>
//                     schema.required("Start Date is required"), // only require validity
//             }),

//             expiryDate: Yup.date()
//                 .min(Yup.ref("createdAt"), "Expiry Date cannot be before Start Date")
//                 .required("Expiry Date is required"),

//         }),

//         onSubmit: async (values) => {
//             console.log("hitting submit");
//             setLoading(true);
//             const token = JSON.parse(localStorage.getItem("token"));
//             const payload = {
//                 ...values,
//                 code: values.code.toUpperCase(),
//             };

//             try {
//                 const response = id
//                     ? await axios.put(`${baseURL}/api/coupon/${id}`, payload, {
//                         headers: {
//                             Authorization: token,
//                             "Content-Type": "application/json",
//                         },
//                     })
//                     : await axios.post(`${baseURL}/api/coupon/`, payload, {
//                         headers: {
//                             Authorization: token,
//                             "Content-Type": "application/json",
//                         },
//                     });
//                 console.log(response)
//                 if (response?.data?.success) {
//                     setLoading(false);
//                     formik.resetForm();
//                     toggleModal();
//                     getData();

//                     Swal.fire({
//                         title: response.data.message || (id ? "Coupon Updated" : "Coupon Added"),
//                         icon: "success",
//                         confirmButtonColor: "#d3178a",
//                     });
//                 }
//             } catch (error) {
//                 setLoading(false);
//                 Swal.fire({
//                     title: error?.response?.data?.message || "Something went wrong",
//                     icon: "error",
//                     confirmButtonColor: "#d3178a",
//                 });
//             }
//         },
//     });

//     const toggleModal = () => {
//         formik.resetForm();
//         setId("");
//         SetAddmodal(!AddModal);
//         setLoading(false);
//     };

//     const debouncedSearch = useRef(
//         debounce(async (searchTerm) => {
//             setSearchTerm(searchTerm);
//         }, 300)
//     ).current;

//     const getEditData = async (id) => {
//         try {
//             const token = JSON.parse(localStorage.getItem("token"));
//             const endPoint = `${baseURL}/api/coupon/${id}`;

//             const response = await axios.get(endPoint, {
//                 headers: {
//                     Authorization: `${token}`,
//                 },
//             });

//             if (response?.data?.success) {
//                 const data = response.data.coupon;

//                 // console.log("data.validFrom", data.validFrom);

//                 if (data) {
//                     if (data.code) formik.setFieldValue("code", data.code);
//                     if (data.discountValue) formik.setFieldValue("discountValue", data.discountValue);
//                     if (data.discountType) formik.setFieldValue("discountType", data.discountType);
//                     if (data.minOrderVal) formik.setFieldValue("minOrderVal", data.minOrderVal);
//                     // if (data.description) formik.setFieldValue("description", data.description);
//                     if (data.maxAmount) formik.setFieldValue("maxAmount", data.maxAmount);
//                     if (data.createdAt) formik.setFieldValue("createdAt", moment(data.createdAt).format("YYYY-MM-DD"));
//                     if (data.expiryDate) formik.setFieldValue("expiryDate", moment(data.expiryDate).format("YYYY-MM-DD"));


//                     // if (data.status) formik.setFieldValue("status", data.status);
//                     // if (data.minimum_purchase_amount !== undefined)
//                     //     formik.setFieldValue("minimum_purchase_amount", data.minimum_purchase_amount);
//                     // if (data.minimum_quantity_items !== undefined)
//                     //     formik.setFieldValue("minimum_quantity_items", data.minimum_quantity_items);
//                     // if (data.purchase_requirement)
//                     //     formik.setFieldValue("purchase_requirement", data.purchase_requirement);
//                 }
//             } else {
//                 Swal.fire({
//                     title: "Failed to load coupon data",
//                     icon: "error",
//                     confirmButtonColor: "#d3178a",
//                 });
//             }
//         } catch (error) {
//             console.error("Error loading coupon data:", error);
//             Swal.fire({
//                 title: error?.response?.data?.message || "Something went wrong while loading data",
//                 icon: "error",
//                 confirmButtonColor: "#d3178a",
//             });
//         }
//     };


//     const getData = async () => {
//         const token = await JSON.parse(localStorage.getItem("token"))
//         try {
//             setIsLoading(true);
//             let endPoint = '/api/coupon';

//             const response = await axios.get(`${baseURL}${endPoint}?search_string=${searchTerm}`, {
//                 headers: {
//                     Authorization: `${token}`,
//                 }
//             });
//             console.log(response)
//             if (response?.status === 200) {
//                 setData(response?.data?.coupons?.reverse());
//                 setIsLoading(false);
//             }
//         } catch (error) {
//             console.log(error)
//             setIsLoading(true);

//         }
//     }

//     const deleteCoupon = async (id) => {
//         if (window.confirm("Do You Want To Delete this Coupon?")) {
//             const token = await JSON.parse(localStorage.getItem("token"))
//             try {
//                 const data = await axios.delete(`${baseURL}/api/coupon/${id}`, {
//                     headers: {
//                         Authorization: `${token}`,
//                     }
//                 })
//                 getData();
//                 Swal.fire({
//                     icon: 'success',
//                     title: data?.data?.message
//                 })
//             } catch (error) {
//                 console.log(error, 'edit')
//             }
//         }
//     }

//     useEffect(() => {
//         getData();
//     }, [searchTerm]);

//     const orderColumns = [
//         {
//             name: 'Coupon Code',
//             selector: row => row?.code,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 <span className="fw-bold text-primary">{row?.code || '-'}</span>
//             ),
//         },
//         {
//             name: 'Discount',
//             selector: row => row?.discountValue,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 <>
//                     {row?.discountValue
//                         ? `${row.discountValue}${row.discountType === "percentage" ? "%" : "₹"}`
//                         : "—"}
//                 </>
//             ),
//         },
//         {
//             name: 'Min Order Value',
//             selector: row => row?.minOrderVal,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 <>{row?.minOrderVal ? `₹${row.minOrderVal}` : "—"}</>
//             ),
//         },
//         {
//             name: 'Max Discount',
//             selector: row => row?.maxAmount,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 <>{row?.maxAmount ? `₹${row.maxAmount}` : "—"}</>
//             ),
//         },
//         {
//             name: 'Start Date',
//             selector: row => row?.createdAt,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 moment(row?.createdAt).format("DD MMM YYYY")
//             ),
//         },
//         {
//             name: 'Expiry Date',
//             selector: row => row?.expiryDate,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 moment(row?.expiryDate).format("DD MMM YYYY")
//             ),
//         },
//         {
//             name: 'Status',
//             selector: row => row?.isActive,
//             sortable: true,
//             center: true,
//             cell: row => (
//                 <span
//                     style={{ fontSize: '13px' }}
//                     className={`badge ${row?.isActive ? "badge-light-success" : "badge-danger"}`}
//                 >
//                     {row?.isActive ? "Active" : "Inactive"}
//                 </span>
//             ),
//         },
//         {
//             name: 'Actions',
//             center: true,
//             cell: (row) => (
//                 <UncontrolledDropdown className='action_dropdown'>
//                     <DropdownToggle className='action_btn'>
//                         <MoreVertical color='#000' size={16} />
//                     </DropdownToggle>
//                     <DropdownMenu>
//                         <DropdownItem
//                             onClick={() => {
//                                 formik.resetForm();
//                                 getEditData(row?._id);
//                                 setId(row?._id);
//                                 SetAddmodal(true);
//                             }}
//                         >
//                             Edit <FaPen className="ms-1" />
//                         </DropdownItem>
//                         <DropdownItem
//                             className='delete_item'
//                             onClick={() => deleteCoupon(row?._id)}
//                         >
//                             Delete <FaTrashAlt className="ms-1" />
//                         </DropdownItem>
//                     </DropdownMenu>
//                 </UncontrolledDropdown>
//             ),
//         },
//     ];

//     return (
//         <Fragment>
//             <Container fluid={true} style={{ paddingTop: '30px' }}>
//                 <Row>
//                     <Col sm="12">
//                         <Card>
//                             <CardBody style={{ padding: '15px' }}>
//                                 <Row xxl={12} className='pb-2'>
//                                     <Row>
//                                         <Col md={6} lg={6} xl={6} xxl={6}>
//                                             <div>
//                                                 <h5 className='mb-0 font-bold'>
//                                                     Coupons
//                                                 </h5>
//                                             </div>
//                                         </Col>
//                                         <Col md={6} lg={6} xl={6} xxl={6}>
//                                             <div className="file-content file-content1 justify-content-end">
//                                                 <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
//                                                     <i className='fa fa-search' style={{ top: 'unset' }}></i>
//                                                     <input className='form-control border-0' style={{ maxWidth: '195px' }} onChange={(e) => debouncedSearch(e.target.value)} type='text' placeholder='Search...' />
//                                                 </div>
//                                                 <Button className='btn btn-primary d-flex align-items-center ms-3' onClick={toggleModal}>
//                                                     <PlusCircle />
//                                                     Add Coupons
//                                                 </Button>
//                                             </div>
//                                         </Col>
//                                     </Row>
//                                 </Row>
//                             </CardBody>

//                             <DataTable
//                                 data={data}
//                                 columns={orderColumns}
//                                 striped={true}
//                                 center={true}
//                                 pagination
//                                 paginationServer
//                                 progressComponent={<Loader />}
//                                 progressPending={isLoading}
//                             />

//                                 <CommonModal
//                                     isOpen={AddModal}
//                                     title={id ? 'Update Coupon' : 'Add Coupon'}
//                                     className="store_modal"
//                                     toggler={toggleModal}
//                                     size="lg"
//                                 >
//                                     <Container>
//                                         <Form className="theme-form" onSubmit={formik.handleSubmit}>
//                                             <Row>
//                                                 {/* Coupon Code */}
//                                                 <Col xl={12}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Coupon Code <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <Input
//                                                             type="text"
//                                                             name="code"
//                                                             placeholder="Enter coupon code (e.g., SAVE20)"
//                                                             onChange={formik.handleChange}
//                                                             onBlur={formik.handleBlur}
//                                                             value={formik.values.code.toUpperCase()}
//                                                         />
//                                                         {formik.touched.code && formik.errors.code && (
//                                                             <span className="error text-danger">{formik.errors.code}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>

//                                                 {/* Discount Type & Value */}
//                                                 <Col xl={12}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Discount Value <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <div className="d-flex gap-2">
//                                                             <Input
//                                                                 type="number"
//                                                                 name="discountValue"
//                                                                 min={1}
//                                                                 placeholder="Enter discount"
//                                                                 onChange={formik.handleChange}
//                                                                 onBlur={formik.handleBlur}
//                                                                 value={formik.values.discountValue}
//                                                                 className="w-75"
//                                                             />
//                                                             <Input
//                                                                 type="select"
//                                                                 name="discountType"
//                                                                 onChange={formik.handleChange}
//                                                                 onBlur={formik.handleBlur}
//                                                                 value={formik.values.discountType}
//                                                                 className="w-25"
//                                                             >
//                                                                 <option value="percentage">%</option>
//                                                                 <option value="flat">₹</option>
//                                                             </Input>
//                                                         </div>
//                                                         {formik.touched.discountValue && formik.errors.discountValue && (
//                                                             <span className="error text-danger">{formik.errors.discountValue}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>

//                                                 {/* Min Order & Max Discount */}
//                                                 <Col xl={6}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Minimum Order Value <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <Input
//                                                             type="number"
//                                                             name="minOrderVal"
//                                                             placeholder="Enter minimum order value"
//                                                             onChange={formik.handleChange}
//                                                             onBlur={formik.handleBlur}
//                                                             value={formik.values.minOrderVal}
//                                                         />
//                                                         {formik.touched.minOrderVal && formik.errors.minOrderVal && (
//                                                             <span className="error text-danger">{formik.errors.minOrderVal}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>

//                                                 <Col xl={6}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Maximum Discount Amount <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <Input
//                                                             type="number"
//                                                             name="maxAmount"
//                                                             placeholder="Enter maximum discount amount"
//                                                             onChange={formik.handleChange}
//                                                             onBlur={formik.handleBlur}
//                                                             value={formik.values.maxAmount}
//                                                         />
//                                                         {formik.touched.maxAmount && formik.errors.maxAmount && (
//                                                             <span className="error text-danger">{formik.errors.maxAmount}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>

//                                                 {/* Validity Dates */}
//                                                 <Col xl={6}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Start Date <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <Input
//                                                             type="date"
//                                                             name="createdAt"
//                                                             onChange={formik.handleChange}
//                                                             onBlur={formik.handleBlur}
//                                                             value={formik.values.createdAt}
//                                                         />
//                                                         {formik.touched.createdAt && formik.errors.createdAt && (
//                                                             <span className="error text-danger">{formik.errors.createdAt}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>

//                                                 <Col xl={6}>
//                                                     <FormGroup>
//                                                         <Label className="font-semibold text-base">
//                                                             Expiry Date <span className="text-danger">*</span>
//                                                         </Label>
//                                                         <Input
//                                                             type="date"
//                                                             name="expiryDate"
//                                                             onChange={formik.handleChange}
//                                                             onBlur={formik.handleBlur}
//                                                             value={formik.values.expiryDate}
//                                                         />
//                                                         {formik.touched.expiryDate && formik.errors.expiryDate && (
//                                                             <span className="error text-danger">{formik.errors.expiryDate}</span>
//                                                         )}
//                                                     </FormGroup>
//                                                 </Col>
//                                                 {/* Submit / Cancel */}
//                                                 <Col xl={12} className="modal_btm d-flex justify-content-end">
//                                                     <Button className="cancel_Btn" onClick={() => SetAddmodal(false)}>
//                                                         Cancel
//                                                     </Button>
//                                                     <Button type="submit" disabled={loading} className="ms-2 btn btn-primary">
//                                                         {id ? "Update Coupon" : "Add Coupon"}
//                                                     </Button>
//                                                 </Col>
//                                             </Row>
//                                         </Form>
//                                     </Container>
//                                 </CommonModal>

//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </Fragment>
//     )
// }
// export default CouponsTable;

import { debounce } from "lodash";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import { MoreVertical, PlusCircle } from "react-feather";
import { FaPen, FaTrashAlt } from "react-icons/fa";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row, UncontrolledDropdown } from "reactstrap";
import { baseURL } from "../../../../Services/api/baseURL";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import CommonModal from "../../../UiKits/Modals/common/modal";
import Loader from "../../../Loader/Loader";

const CouponsTable = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [AddModal, SetAddmodal] = useState(false);
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]); // full list used for client-side filtering
    const [pagination, setPagination] = useState({ perPage: 10, page: 1 });
    const [token, setToken] = useState(null);
    const [id, setId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('token'))
        if (token) {
            setToken(token);
            return;
        }
        setToken(null);
    }, []);

    const formik = useFormik({
        initialValues: {
            code: "",
            // description: "",
            discountType: "percentage",
            discountValue: "",
            minOrderVal: "",
            maxAmount: "",
            createdAt: moment().format("YYYY-MM-DD"), // default to today
            expiryDate: "",
        },
        validationSchema: Yup.object({
            code: Yup.string()
                .transform((v) => v?.toUpperCase())
                .required("Coupon Code is required"),

            discountValue: Yup.number()
                .typeError("Discount Value must be a number")
                .positive("Discount must be positive")
                .required("Discount Value is required"),

            discountType: Yup.string()
                .oneOf(["percentage", "flat"], "Invalid Discount Type")
                .required("Discount Type is required"),

            minOrderVal: Yup.number()
                .typeError("Min Order Value must be a number")
                .min(0, "Cannot be negative")
                .required("Minimum Order Value is required"),

            maxAmount: Yup.number()
                .typeError("Max Discount Amount must be a number")
                .min(0, "Cannot be negative")
                .required("Maximum Discount Amount is required"),

            createdAt: Yup.date()
                .when([], {
                    // 'id' is taken from outer scope
                    is: () => !id, // only validate "no past" when creating
                    then: (schema) =>
                        schema
                            .min(
                                moment().subtract(1, "day").toDate(),
                                "Start Date cannot be in the past"
                            )
                            .required("Start Date is required"),
                    otherwise: (schema) =>
                        schema.required("Start Date is required"), // only require validity
                }),

            expiryDate: Yup.date()
                .min(Yup.ref("createdAt"), "Expiry Date cannot be before Start Date")
                .required("Expiry Date is required"),

        }),

        onSubmit: async (values) => {
            setLoading(true);
            const token = JSON.parse(localStorage.getItem("token"));
            const payload = {
                ...values,
                code: values.code.toUpperCase(),
            };

            try {
                const response = id
                    ? await axios.put(`${baseURL}/api/coupon/${id}`, payload, {
                        headers: {
                            Authorization: token,
                            "Content-Type": "application/json",
                        },
                    })
                    : await axios.post(`${baseURL}/api/coupon/`, payload, {
                        headers: {
                            Authorization: token,
                            "Content-Type": "application/json",
                        },
                    });

                if (response?.data?.success) {
                    setLoading(false);
                    formik.resetForm();
                    SetAddmodal(false);
                    getData();
                    await Swal.fire({
                        title: response.data.message || (id ? "Coupon Updated" : "Coupon Added"),
                        icon: "success",
                        confirmButtonColor: "#d3178a",
                    });
                }
            } catch (error) {
                setLoading(false);
                Swal.fire({
                    title: error?.response?.data?.message || "Something went wrong",
                    icon: "error",
                    confirmButtonColor: "#d3178a",
                });
            }
        },
    });

    const toggleModal = () => {
        formik.resetForm();
        setId("");
        SetAddmodal(!AddModal);
        setLoading(false);
    };

    const debouncedSearch = useRef(
        debounce(async (searchTerm) => {
            setSearchTerm(searchTerm);
        }, 300)
    ).current;

    const getEditData = async (id) => {
        try {
            const token = JSON.parse(localStorage.getItem("token"));
            const endPoint = `${baseURL}/api/coupon/${id}`;

            const response = await axios.get(endPoint, {
                headers: {
                    Authorization: `${token}`,
                },
            });

            if (response?.data?.success) {
                const data = response.data.coupon;

                if (data) {
                    if (data.code) formik.setFieldValue("code", data.code);
                    if (data.discountValue) formik.setFieldValue("discountValue", data.discountValue);
                    if (data.discountType) formik.setFieldValue("discountType", data.discountType);
                    if (data.minOrderVal) formik.setFieldValue("minOrderVal", data.minOrderVal);
                    if (data.maxAmount) formik.setFieldValue("maxAmount", data.maxAmount);
                    if (data.createdAt) formik.setFieldValue("createdAt", moment(data.createdAt).format("YYYY-MM-DD"));
                    if (data.expiryDate) formik.setFieldValue("expiryDate", moment(data.expiryDate).format("YYYY-MM-DD"));
                }
            } else {
                Swal.fire({
                    title: "Failed to load coupon data",
                    icon: "error",
                    confirmButtonColor: "#d3178a",
                });
            }
        } catch (error) {
            console.error("Error loading coupon data:", error);
            Swal.fire({
                title: error?.response?.data?.message || "Something went wrong while loading data",
                icon: "error",
                confirmButtonColor: "#d3178a",
            });
        }
    };


    const getData = async () => {
        const token = await JSON.parse(localStorage.getItem("token"))
        try {
            setIsLoading(true);
            const response = await axios.get(`${baseURL}/api/coupon`, {
                headers: {
                    Authorization: `${token}`,
                }
            });
            if (response?.status === 200) {
                const coupons = response?.data?.coupons || [];
                const reversed = [...coupons].reverse();
                setAllData(reversed); // store full set for filtering
                setData(reversed);    // visible set
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error)
            setIsLoading(false);
        }
    }

    const deleteCoupon = async (id) => {
        if (window.confirm("Do You Want To Delete this Coupon?")) {
            const token = await JSON.parse(localStorage.getItem("token"))
            try {
                const data = await axios.delete(`${baseURL}/api/coupon/${id}`, {
                    headers: {
                        Authorization: `${token}`,
                    }
                })
                getData();
                Swal.fire({
                    icon: 'success',
                    title: data?.data?.message
                })
            } catch (error) {
                console.log(error, 'edit')
            }
        }
    }

    useEffect(() => {
        getData();
    }, []); // fetch once on mount

    // client-side filtering whenever searchTerm changes
    useEffect(() => {
        if (!searchTerm || !searchTerm.toString().trim()) {
            setData(allData);
            return;
        }

        const q = searchTerm.toString().trim().toLowerCase();
        const numericQ = Number(q);
        const isNumberQuery = !Number.isNaN(numericQ);

        const filtered = allData.filter((c) => {
            const code = (c.code || "").toString().toLowerCase();
            const codeMatch = code.includes(q);

            const discountStr = (c.discountValue ?? "").toString().toLowerCase();
            const discountMatch = discountStr.includes(q);

            if (isNumberQuery) {
                return codeMatch || (c.discountValue !== undefined && Number(c.discountValue) === numericQ) || discountMatch;
            }
            return codeMatch || discountMatch;
        });

        setData(filtered);
    }, [searchTerm, allData]);

    const orderColumns = [
        {
            name: 'Coupon Code',
            selector: row => row?.code,
            sortable: true,
            center: true,
            cell: row => (
                <span className="fw-bold text-primary">{row?.code || '-'}</span>
            ),
        },
        {
            name: 'Discount',
            selector: row => row?.discountValue,
            sortable: true,
            center: true,
            cell: row => (
                <>
                    {row?.discountValue
                        ? `${row.discountValue}${row.discountType === "percentage" ? "%" : "₹"}`
                        : "—"}
                </>
            ),
        },
        {
            name: 'Min Order Value',
            selector: row => row?.minOrderVal,
            sortable: true,
            center: true,
            cell: row => (
                <>{row?.minOrderVal ? `₹${row.minOrderVal}` : "—"}</>
            ),
        },
        {
            name: 'Max Discount',
            selector: row => row?.maxAmount,
            sortable: true,
            center: true,
            cell: row => (
                <>{row?.maxAmount ? `₹${row.maxAmount}` : "—"}</>
            ),
        },
        {
            name: 'Start Date',
            selector: row => row?.createdAt,
            sortable: true,
            center: true,
            cell: row => (
                moment(row?.createdAt).format("DD MMM YYYY")
            ),
        },
        {
            name: 'Expiry Date',
            selector: row => row?.expiryDate,
            sortable: true,
            center: true,
            cell: row => (
                moment(row?.expiryDate).format("DD MMM YYYY")
            ),
        },
        {
            name: 'Status',
            selector: row => row?.isActive,
            sortable: true,
            center: true,
            cell: row => (
                <span
                    style={{ fontSize: '13px' }}
                    className={`badge ${row?.isActive ? "badge-light-success" : "badge-danger"}`}
                >
                    {row?.isActive ? "Active" : "Inactive"}
                </span>
            ),
        },
        {
            name: 'Actions',
            center: true,
            cell: (row) => (
                <UncontrolledDropdown className='action_dropdown'>
                    <DropdownToggle className='action_btn'>
                        <MoreVertical color='#000' size={16} />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem
                            onClick={() => {
                                formik.resetForm();
                                getEditData(row?._id);
                                setId(row?._id);
                                SetAddmodal(true);
                            }}
                        >
                            Edit <FaPen className="ms-1" />
                        </DropdownItem>
                        <DropdownItem
                            className='delete_item'
                            onClick={() => deleteCoupon(row?._id)}
                        >
                            Delete <FaTrashAlt className="ms-1" />
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            ),
        },
    ];

    return (
        <Fragment>
            <Container fluid={true} style={{ paddingTop: '30px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody style={{ padding: '15px' }}>
                                <Row xxl={12} className='pb-2'>
                                    <Row>
                                        <Col md={6} lg={6} xl={6} xxl={6}>
                                            <div>
                                                <h5 className='mb-0 font-bold'>
                                                    Coupons
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col md={6} lg={6} xl={6} xxl={6}>
                                            <div className="file-content file-content1 justify-content-end">
                                                <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                                    <i className='fa fa-search' style={{ top: 'unset' }}></i>
                                                    <input className='form-control border-0' style={{ maxWidth: '195px' }} onChange={(e) => debouncedSearch(e.target.value)} type='text' placeholder='Search by code or discount' />
                                                </div>
                                                <Button className='btn btn-primary d-flex align-items-center ms-3' onClick={toggleModal}>
                                                    <PlusCircle />
                                                    Add Coupons
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Row>
                            </CardBody>

                            <DataTable
                                data={data}
                                columns={orderColumns}
                                striped={true}
                                center={true}
                                pagination
                                paginationPerPage={pagination.perPage}
                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                onChangePage={(page) => setPagination(prev => ({ ...prev, page }))}
                                onChangeRowsPerPage={(newPerPage) => setPagination(prev => ({ ...prev, perPage: newPerPage, page: 1 }))}
                                paginationServer={false}
                                progressComponent={<Loader />}
                                progressPending={isLoading}
                            />

                                <CommonModal
                                    isOpen={AddModal}
                                    title={id ? 'Update Coupon' : 'Add Coupon'}
                                    className="store_modal"
                                    toggler={toggleModal}
                                    size="lg"
                                >
                                    <Container>
                                        <Form className="theme-form" onSubmit={formik.handleSubmit}>
                                            <Row>
                                                {/* Coupon Code */}
                                                <Col xl={12}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Coupon Code <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            name="code"
                                                            placeholder="Enter coupon code (e.g., SAVE20)"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.code.toUpperCase()}
                                                        />
                                                        {formik.touched.code && formik.errors.code && (
                                                            <span className="error text-danger">{formik.errors.code}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                {/* Discount Type & Value */}
                                                <Col xl={12}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Discount Value <span className="text-danger">*</span>
                                                        </Label>
                                                        <div className="d-flex gap-2">
                                                            <Input
                                                                type="number"
                                                                name="discountValue"
                                                                min={1}
                                                                placeholder="Enter discount"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.discountValue}
                                                                className="w-75"
                                                            />
                                                            <Input
                                                                type="select"
                                                                name="discountType"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.discountType}
                                                                className="w-25"
                                                            >
                                                                <option value="percentage">%</option>
                                                                <option value="flat">₹</option>
                                                            </Input>
                                                        </div>
                                                        {formik.touched.discountValue && formik.errors.discountValue && (
                                                            <span className="error text-danger">{formik.errors.discountValue}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                {/* Min Order & Max Discount */}
                                                <Col xl={6}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Minimum Order Value <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            name="minOrderVal"
                                                            placeholder="Enter minimum order value"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.minOrderVal}
                                                        />
                                                        {formik.touched.minOrderVal && formik.errors.minOrderVal && (
                                                            <span className="error text-danger">{formik.errors.minOrderVal}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                <Col xl={6}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Maximum Discount Amount <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="number"
                                                            name="maxAmount"
                                                            placeholder="Enter maximum discount amount"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.maxAmount}
                                                        />
                                                        {formik.touched.maxAmount && formik.errors.maxAmount && (
                                                            <span className="error text-danger">{formik.errors.maxAmount}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                {/* Validity Dates */}
                                                <Col xl={6}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Start Date <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="date"
                                                            name="createdAt"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.createdAt}
                                                        />
                                                        {formik.touched.createdAt && formik.errors.createdAt && (
                                                            <span className="error text-danger">{formik.errors.createdAt}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                <Col xl={6}>
                                                    <FormGroup>
                                                        <Label className="font-semibold text-base">
                                                            Expiry Date <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="date"
                                                            name="expiryDate"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.expiryDate}
                                                        />
                                                        {formik.touched.expiryDate && formik.errors.expiryDate && (
                                                            <span className="error text-danger">{formik.errors.expiryDate}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                {/* Submit / Cancel */}
                                                <Col xl={12} className="modal_btm d-flex justify-content-end">
                                                    <Button className="cancel_Btn" onClick={() => SetAddmodal(false)}>
                                                        Cancel
                                                    </Button>
                                                    <Button type="submit" disabled={loading} className="ms-2 btn btn-primary">
                                                        {id ? "Update Coupon" : "Add Coupon"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Container>
                                </CommonModal>

                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
export default CouponsTable;
